import React from 'react';
import type { RegieType } from '@/types';

export type RegieContextType = {
  // Liste des régies
  regies: RegieType[];
  // Identifiant de la régie sélectionnée
  selectedRegie?: number;
  // Affiche la liste des régies
  showList?: () => void;
  // Affiche la liste des régies
  selectRegie?: (regie: RegieType) => void;
};

const RegieContext = React.createContext<RegieContextType>({
  regies: null,
  selectedRegie: null,
  showList: null,
  selectRegie: null,
});

export default RegieContext;
